/**
 * @file src/components/molecules/QuestionButton/QuestionButton.tsx
 * @description Defines a reusable QuestionButton component which renders a button with a question icon.
 * @module QuestionButton
 */

import React, { FC } from 'react';
import { Button } from '@/components/atoms';

interface QuestionButtonProps {
  onClick: () => void;
  className?: string;
}

const QuestionButton: FC<QuestionButtonProps> = ({ onClick, className }) => {
  return (
    <Button
      icon="question"
      intent="ghost"
      onClick={onClick}
      flexHeight
      className={className}
    />
  );
};

export default QuestionButton;
